console.log("🚀 DeepLinkingConfig.js loaded!");

export const deepLinkingConfig = {
  screens: {
    WebScreenStack: {
      initialRouteName: "",
      screens: {
        LoginWebScreen: "/auth/login",
        HomeWebScreenStatic: "/auth/home-static",
        SetupScreen: "/auth/setup",
        ChooseGameLikeScreen: "/auth/choose-games",
        ChooseAvatarScreen: "/auth/choose-avatar",
        SignupWebScreen: "/auth/signup",
        EmailConfirmationWebScreen: "/auth/email-confirmation",
        ResetPasswordWebScreen: "/auth/reset-password",
        ResetSetPasswordWebScreen: "/auth/reset-password-confirm",
        GameShowPreviewScreen: "/events/game-show-preview",
        ShortUrlRedirectScreen: {
          path: "/e/:url",
          parse: {
            url: (url) => url,
            ref: (ref) => ref,
          },
        },
        SimpleShortUrlRedirectScreen: {
          path: "/ko/:shortCode",
          parse: {
            shortCode: (shortCode) => shortCode,
          },
        },
        EventTypeScreen: "/events/create",
        "payment/success": "/payment/success",
        "payment/failure": "/payment/failure", // Viva uses /failure
        "payment/cancel": "/payment/cancel",
        DrawerRoute: {
          initialRouteName: "HomeScreen",
          screens: {
            HomeTabStack: {
              initialRouteName: "HomeScreen",
              screens: {
                HomeScreen: "/dashboard",
                TicketDetailWebScreen: "/ticket-detail",
                TicketHistory: "/ticket-history",
                SearchEventWebScreen: "/search",
                SearchMobileScreen: "/search-mobile",
                SearchGameWebScreen: "/search-games",
                RefundRequestScreen: "/refund-request",
                SoloStreaming: {
                  path: "/streaming/:username",
                  parse: {
                    username: (username) => username,
                  },
                },
                StreamerGoLive: "/go-live",
              },
            },
            MyEventsTabStack: {
              initialRouteName: "MyEventsScreen",
              screens: {
                MyEventsScreen: "/events",
                CreatePublicEventScreen: "/events/create/public",
                CreatePrivateEventScreen: "/events/create/private",
                UpdatePublicEventScreen: "/events/edit/public",
                UpdatePrivateEventScreen: "/events/edit/private",
                EventSummary: "/event-summary",
                PrivateEventSummary: "/private-event-summary",
                OnGoingGameShow: "/events/ongoing-game-shows",
                GameShowScreen: "/events/game-show",
                OnGoingEvents: "/events/ongoing",
                OnGoingEventsStreamingSetup: "/events/ongoing-streaming-setup",
                StreamSetup: "/events/stream-setup",
                StreamingSetup: "/events/streaming-setup",
                GoLive: "/events/go-live",
                LiveStreaming: "/events/live-stream",
                PastEvent: "/events/past",
                disputeCenter: "/dispute-center",
              },
            },
            HelpChatTabStack: {
              initialRouteName: "ChatScreen",
              screens: {
                ChatScreen: "/support-chat",
              },
            },
            PurchaseTabStack: {
              initialRouteName: "PurchaseScreen",
              screens: {
                PurchaseScreen: "/profile/purchase-tokens",
              },
            },
            ProfileTabStack: {
              initialRouteName: "Profile",
              screens: {
                Profile: "/profile",
                ChangeAvatar: "/profile/change-avatar",
                Redeem: "/profile/redeem",
                ViewTrasactionHistory: "/profile/transactions",
                UserProfile: "/profile/user",
              },
            },
            HelpTabStack: {
              initialRouteName: "Help",
              path: "help",
              screens: {
                Help: {
                  path: "",
                  parse: {
                    tab: (tab) => tab || "gettingStarted",
                  },
                  stringify: {
                    tab: (tab) => tab,
                  },
                },
                DisputeCenter: "disputes",
                ContactUsCenter: "contact-us",
                CreateTicketEventScreen: "create-ticket",
              },
            },
            DisputeTabStack: {
              initialRouteName: "DisputeManagementScreen",
              screens: {
                DisputeManagementScreen: "/disputes",
                DisputeDetailScreen: "/disputes/detail",
              },
            },
            NotificationTabStack: {
              initialRouteName: "Notifications",
              screens: {
                Notifications: "/notifications",
              },
            },
            SettingTabStack: {
              initialRouteName: "SettingWebScreen",
              path: "settings",
              screens: {
                SettingWebScreen: {
                  path: "",
                  parse: {
                    tab: (tab) => tab || "account",
                  },
                  stringify: {
                    tab: (tab) => tab,
                  },
                },
              },
            },
            ChatTabStack: {
              initialRouteName: "Chat",
              screens: {
                Chat: "/messages",
                AddFriends: "/messages/add-friends",
              },
            },
            PaymentDone: "/payment-success",
          },
        },
      },
    },
  },
};

console.log(
  "✅ CreatePublicEventScreen URL:",
  deepLinkingConfig.screens.WebScreenStack.screens.DrawerRoute.screens
    .MyEventsTabStack.screens.CreatePublicEventScreen
);
